import React, { useState } from 'react'
import { Query, Mutation } from 'react-apollo'
import _ from 'lodash'
import {
  Div, P, Loading, Button as KonsysButton, InputWithLabel,
} from 'konsys-ui'
import { Modal, message } from 'antd'
import { ADD_SHIPPING_ORDER_TO_INVOICE } from '../../../constants/graphql/mutation'
import detailType from '../util-functions'
import { GET_SUM_INFO_INVOICE, INVOICE_INFO } from '../../../constants/graphql/query'
import { PaidInfo, ShippingLog } from './extension-component'

const AddRemoveShipping = ({ props }) => {
  const [mutationVariables, setMutationVariables] = useState({})
  const [modal, setModal] = useState(false)

  let onChangeHandler = (id, value) => {
    setMutationVariables({
      ...mutationVariables,
      [id]: value,
    })
  }

  let initialData = {}

  return (
    <Div display='flex' flexDirection='column'>
      {
        <Query
          query={INVOICE_INFO}
          variables={{
            id: props.match.params.id,
          }}
        >
          {
            ({
              data: invoice, error: invoiceError, loading: invoiceLoading,
            }) => {
              if (invoiceLoading && _.isEmpty(invoice)) return <Loading />
              if (invoiceError) return <P>เกิดข้อผิดพลาด</P>
              return (
                <Div>
                  <Query
                    query={GET_SUM_INFO_INVOICE}
                    variables={{
                      id: _.map(invoice.InvoiceInfo.shippings, v => v.id),
                      invoiceId: parseInt(props.match.params.id, 10),
                    }}
                  >
                    {
                      ({
                        data: sum, error: sumError, loading: sumLoading, refetch: sumRefetch,
                      }) => {
                        if (sumLoading && _.isEmpty(invoice)) return <Loading />
                        if (sumError) return <P>เกิดข้อผิดพลาด</P>
                        initialData = {
                          ...invoice.InvoiceInfo,
                          customerId: invoice.InvoiceInfo.Job.customerId,
                          dealType: invoice.InvoiceInfo.Job.dealType,
                          unit: invoice.InvoiceInfo.Job.unit,
                          companyName: !_.isNull(invoice.InvoiceInfo.Job.Customer) && invoice.InvoiceInfo.Job.Customer.companyName,
                          companyId: !_.isNull(invoice.InvoiceInfo.Job.Customer) && invoice.InvoiceInfo.Job.Customer.companyId,
                          groupId: !_.isNull(invoice.InvoiceInfo.Job.Customer) && invoice.InvoiceInfo.Job.Customer.groupId,
                          branch: !_.isNull(invoice.InvoiceInfo.Job.Customer) && invoice.InvoiceInfo.Job.Customer.branch,
                          cargo: invoice.InvoiceInfo.Job.cargo,
                          contractWeight: invoice.InvoiceInfo.Job.contractWeight,
                          deliveredWeight: invoice.InvoiceInfo.Job.deliveredWeight,
                          credit: invoice.InvoiceInfo.Job.Customer.credit,
                          customerRefId: invoice.InvoiceInfo.customerRefId,
                          shippingCount: invoice.InvoiceInfo.shippings.length,
                          ...sum.calculateDeliveredShipping,
                        }
                        onChangeHandler = (id, value) => {
                          setMutationVariables({
                            volume: initialData.volume,
                            number: initialData.number,
                            createdDate: initialData.createdDate,
                            dueDate: initialData.dueDate,
                            ...mutationVariables,
                            [id]: id === 'volume' || id === 'number' ? parseInt(value, 10) : value,
                          })
                        }
                        return (
                          <Div>
                            {
                              detailType(props.match.params, onChangeHandler, mutationVariables, initialData)
                            }
                            <Div display='flex' justifyContent='flex-end'>
                              <KonsysButton
                                text='เพิ่มShipping Order'
                                icon='fas fa-plus'
                                //  loading={isLoading[0]}
                                onClick={() => {
                                  setModal(true)
                                }}
                              />
                            </Div>
                            {
                              !_.isEmpty(invoice.InvoiceInfo.shippings)
                              && <ShippingLog data={{
                                ...invoice.InvoiceInfo,
                                jobDealType: invoice.InvoiceInfo.Job.dealType,
                                jobUnit: invoice.InvoiceInfo.Job.unit,
                                isMithrGroup: invoice.InvoiceInfo.Job.Customer.groupId === 6,
                              }} update={true} />
                            }
                            <Div display='flex' justifyContent='flex-end'>
                              <KonsysButton
                                text='เพิ่มShipping Order'
                                icon='fas fa-plus'
                                //  loading={isLoading[0]}
                                onClick={() => {
                                  setModal(true)
                                }}
                              />
                              <AddShippingModal id={props.match.params.id} modal={modal} setModal={setModal} isLoading={sumLoading}/>
                            </Div>
                          </Div>
                        )
                      }
                    }
                  </Query>
                </Div>
              )
            }
          }
        </Query>
      }
    </Div>
  )
}

const AddShippingModal = ({
  id, setModal, modal, isLoading,
}) => {
  const [shippingVolume, setShippingVolume] = useState()
  const [shippingNumber, setShippingNumber] = useState()
  return (
    <Mutation
      mutation={ADD_SHIPPING_ORDER_TO_INVOICE}
      refetchQueries={['InvoiceInfo', 'calculateDeliveredShipping']}
    >{(doAdd, { loading }) => (
      <Modal
        title="เพิ่ม Shipping Order"
        visible={modal}
        destroyOnClose={true}
        onCancel={() => {
          setModal(false)
          setShippingNumber()
          setShippingVolume()
        }}
        onOk={() => {
          doAdd({
            variables: {
              invoiceId: parseInt(id, 10),
              shippingVolume,
              shippingNumber,
            },
          }).then((resp) => {
            const response = resp.data.AddShippingorderToInvoice
            if (response.success) {
              message.success(response.message)
            } else message.error(response.message)
          })
          setModal(false)
          setShippingNumber()
          setShippingVolume()
        }}
        okButtonProps={{
          disabled: _.isEmpty(shippingNumber) || _.isEmpty(shippingVolume) || isLoading,
          loading: isLoading,
        }}
        cancelButtonProps={{
          disabled: isLoading,
        }}
      >
        <Div>
          <InputWithLabel
            title={{ text: 'เล่มที่ใบสั่งบรรทุก' }}
            margin='0 16px 0 0'
            input={{ onChange: e => setShippingVolume(e.target.value), value: shippingVolume }} />
          <InputWithLabel
            title={{ text: 'เลขที่ใบสั่งจ่าย' }}
            margin='0 16px 0 0'
            input={{ onChange: e => setShippingNumber(e.target.value), value: shippingNumber }} />
        </Div>
      </Modal>
    )}
    </Mutation>
  )
}

export default AddRemoveShipping
export { AddRemoveShipping }
